import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import icons from "../../lib/icons";
import RadioBtn from "../../shared/RadioBtn";
import { cn } from "../../utils/utils";
import TwoFactorSettings from "./TowFA";
import { useUpdateUserFixedPasswordState } from "../../lib/queries/queriesAndMutations";
import { useQueryClient } from "@tanstack/react-query";

const ProfileSecuritySection = ({
  items,

  twoFactorSettings,
  setTwoFactorSettings,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutateAsync: updateFixedPass, isPending } =
    useUpdateUserFixedPasswordState();

  const toggleFixedPasswordStatus = async (currentStatus) => {
    try {
      const response = await updateFixedPass(currentStatus);

      if (response.status === 200) {
        toast.success("درخواست شما با موفقیت ثبت شد");
        queryClient.invalidateQueries({ queryKey: ["getProfile"] });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const SectionRow = ({ label, radioChecked, onRadioClick, children }) => (
    <div className="flex flex-col gap-3">
      <div className="w-full flex items-center justify-between">
        <p className="flex-1 text-[14px]">{label}</p>
        <RadioBtn checked={radioChecked} onClick={onRadioClick} />
      </div>
      {children}
    </div>
  );

  return (
    <div className="flex flex-col gap-4 ">
      <div className="flex flex-col bg-primary-20 rounded-[12px] p-[10px] w-full gap-2">
        <div className="flex items-center gap-2">
          <div className="bg-[#E7E9EC] p-[10px] rounded-lg">
            <img src={icons.key} alt="security-icon" width={16} height={16} />
          </div>
          <p className="flex-1 font-semibold text-[12px]">گذرواژه</p>
        </div>
        <div className="flex flex-col gap-3">
          <div className="w-full flex items-center justify-between">
            <p className="flex-1 text-[14px]"> ورود به اپلیکیشن</p>
          </div>
          <button
            className="btn-edit flex items-center gap-1 mr-auto"
            onClick={() => navigate("/verify-old-password")}
          >
            <p>ویرایش</p>
            <img src={icons.edit} alt="edit-icon" width={16} height={16} />
          </button>
        </div>

        <div className="w-full h-[1px] bg-neutral-30" />

        <SectionRow
          label="رمز ثابت انتقال وجه"
          radioChecked={items.fixed_password_status}
          onRadioClick={() =>
            toggleFixedPasswordStatus(items.fixed_password_status)
          }
        >
          <div className="w-fit flex gap-2 items-center mr-auto">
            <button
              className={cn(
                "btn-edit",
                "flex items-center gap-1 mr-auto px-2 py-1"
              )}
              onClick={() => navigate("/change-fixed-pass")}
            >
              <p>ویرایش</p>
              <img src={icons.edit} alt="edit-icon" width={16} height={16} />
            </button>
          </div>
        </SectionRow>
      </div>
      <TwoFactorSettings
        twoFactorSettings={twoFactorSettings}
        setTwoFactorSettings={setTwoFactorSettings}
      />
    </div>
  );
};

export default ProfileSecuritySection;
